export enum API_ROUTES {
  USER = 'user/',
  CUSTOMER = 'customer/',
  EMISSION_MAPPING = 'emission-mapping/',
  EMPLOYEE_COST = 'employee-cost/',
}
